var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75684 5.07129C8.46061 5.07129 8.20768 4.97331 7.99805 4.77734C7.79297 4.57682 7.69043 4.33301 7.69043 4.0459C7.69043 3.75423 7.79525 3.50814 8.00488 3.30762C8.21452 3.10254 8.46517 3 8.75684 3C9.0485 3 9.29915 3.10254 9.50879 3.30762C9.71842 3.50814 9.82324 3.75423 9.82324 4.0459C9.82324 4.33301 9.71842 4.57682 9.50879 4.77734C9.30371 4.97331 9.05306 5.07129 8.75684 5.07129ZM7.01367 12.6523C7.4375 12.6523 7.70182 12.6136 7.80664 12.5361C7.91602 12.4541 7.9821 12.3675 8.00488 12.2764C8.02767 12.1852 8.03906 12.0713 8.03906 11.9346V8.16797C8.03906 7.83984 8.00944 7.62565 7.9502 7.52539C7.89551 7.42513 7.74284 7.375 7.49219 7.375H7V6.62305C7.44661 6.62305 7.79753 6.59115 8.05273 6.52734C8.30794 6.45898 8.48796 6.41113 8.59277 6.38379C8.69759 6.35189 8.81152 6.33594 8.93457 6.33594C9.17155 6.33594 9.3265 6.40658 9.39941 6.54785C9.47689 6.68457 9.51562 6.9056 9.51562 7.21094V11.9346C9.51562 12.2217 9.5612 12.4017 9.65234 12.4746C9.80729 12.5931 10.1012 12.6523 10.5342 12.6523V13.4043H7.01367V12.6523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.70b4bb83b67db01346f17cf7ae40ffcd.svg";
export { ForwardRef as ReactComponent };